import React from "react";
import { TopClassesPageMetadata } from "./TopClassesPage.metadata";
import { TopClassesPageView } from "./TopClassesPage.view";
import { bestClasses } from "../../constants/bestClasses";

export async function getStaticPaths() {
  const paths = bestClasses.map(content => {
    return {
      params: { slug: content.slug }
    };
  });

  return {
    paths,
    fallback: false
  };
}

export async function getStaticProps({ params }) {
  const slug = params.slug;
  const data = bestClasses.filter(content => content.slug === slug)[0];
  return {
    props: {
      topClasses: data
    }
  };
}

export function TopClassesPage(props) {
  return (
    <div>
      <TopClassesPageMetadata {...props} />
      <TopClassesPageView {...props} />
    </div>
  );
}
